import { render } from "./PointsIcon.vue?vue&type=template&id=81b4754a"
import script from "./PointsIcon.vue?vue&type=script&lang=js"
export * from "./PointsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script